export * from './catalog-header';
export * from './catalog-menu';
export * from './catalog-sub-menu';

import { CatalogHeaderComponent } from './catalog-header';
import { CatalogMenuComponent } from './catalog-menu';
import { CatalogSubMenuComponent } from './catalog-sub-menu';

export const CatalogLayoutOrganisms = [
    CatalogHeaderComponent,
    CatalogMenuComponent,
    CatalogSubMenuComponent
]